import { orgRequest } from '@/api/orgClient'

/** GET /org/main 详情子集（展示所属空间用） */
export interface OrgDetail {
  id: string
  name: string
  name_i18n?: string
  logo?: string
}

/** 当前 X-Org-Id 对应空间详情 */
export function getOrg(orgId?: string | null) {
  return orgRequest<OrgDetail>('/org/main', { orgId })
}
